import { StoreState } from "store";

export const getWeekendGetaways = (state: StoreState) => state.weekendGetaways;
